import { ethers, constants } from "ethers";
import {
  createSlice,
  createSelector,
  createAsyncThunk,
  PayloadAction,
} from "@reduxjs/toolkit";
// import { useSnackbar } from "notistack";
import { toast } from "react-toastify";
import { NETWORKS } from "../../constants/blockchain";
import { DEFAULT_CHAIN_ID } from "../../constants/blockchain";

import {
  JsonRpcProvider,
  StaticJsonRpcProvider,
} from "@ethersproject/providers";

import { Networks } from "../../constants/blockchain";
import { messages } from "../../constants/messages";
import { BigNumber } from "ethers";
import { RootState } from "../store";
import { getCTESTContract, getBTESTContract } from "../../helpers/contracts";
import { TransactionToastMessage } from "../../components/TransactionToastMessage";
const scannerURL = NETWORKS[DEFAULT_CHAIN_ID].blockExplorerUrls[0];

interface IBTestMint {
  quantity: number;
  to: string;
  networkID: Networks;
  provider: StaticJsonRpcProvider | JsonRpcProvider;
}

const displayToast = async (msg: string, hash: string) => {
  toast(TransactionToastMessage(msg, hash));
};
export const btestMint = createAsyncThunk(
  "mint/btestMint",
  async ({ quantity, to, networkID, provider }: IBTestMint, { dispatch }) => {
    console.log("mint/btestMint");

    const con = getBTESTContract(provider.getSigner());

    let mintTx;
    // let newAddress;
    // let newSymbol;

    try {
      mintTx = await con.mint(quantity, to);
      // TODO: better to show toast notification.
      console.log("start mintTx.wait ");
      // const id = toast.loading("Sending transaction...");
      displayToast("Sending transaction...", mintTx.hash);
      console.log("mintTx.hash: ", mintTx.hash);
      try {
        await mintTx.wait();
        console.log("finish mintTx.wait ");
        console.log("mintTx.hash: ", mintTx.hash);
        displayToast("Minted successfully...", mintTx.hash);
        // toast.update(id, {
        //   render: "Minted successfully",
        //   type: "success",
        //   autoClose: 5000,
        //   isLoading: false,
        // });
      } catch (err: any) {
        console.log("err:", err);
        toast(err.reason);

        // toast.update(id, {
        //   render: "All is good",
        //   type: "error",
        //   isLoading: false,
        // });
        //   return metamaskErrorWrap(err, dispatch);
      } finally {
        console.log("finally");
        if (mintTx) {
          console.log("mintTx: ", mintTx);
          // dispatch(clearPendingTxn(bondTx.hash));
        }
      }

      // TODO: better to show toast notification again.

      // dispatch(success({ text: messages.tx_successfully_updated }));
    } catch (err: any) {
      console.log("err:", err);
      displayToast("error: ", err.reason);
      //   return metamaskErrorWrap(err, dispatch);
    } finally {
      console.log("finally");
      if (mintTx) {
        console.log("mintTx: ", mintTx);
        // dispatch(clearPendingTxn(bondTx.hash));
      }
    }

    return {
      // newAddress: newAddress,
      // newSymbol: newSymbol,
    };
  }
);

export interface IBTestMintSlice {
  loading: boolean;
  // newAddress: string;
  // newSymbol: string;
  // newTitle: string;
  // newDescription: string;
  [key: string]: any;
}
const initialState: IBTestMintSlice = {
  loading: false,
  //   mintAddress: "",
  // newAddress: "",
  // newSymbol: "",
};

const btestSlice = createSlice({
  name: "btest",
  initialState,
  reducers: {
    // fetchMintSuccess(state, action) {
    //   state[action.payload.bond] = action.payload;
    // },
    // clearNewCreatedMint(state, action: PayloadAction<string>) {
    // clearNewCreatedMint(state) {
    //   // const target = state.find(x => x.txnHash === action.payload);
    //   // if (target) {
    //   //     state.splice(state.indexOf(target), 1);
    //   // }
    //   state.loading = false;
    //   state.newAddress = "";
    //   state.newSymbol = "";
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(btestMint.pending, (state) => {
        state.loading = true;
      })
      .addCase(btestMint.fulfilled, (state, action) => {
        console.log("action.payload: ", action.payload);
        state.loading = false;
      })
      .addCase(btestMint.rejected, (state, { error }) => {
        state.loading = false;
        console.log(error);
      });
  },
});

export default btestSlice.reducer;

// export const { clearNewCreatedMint } = mintSlice.actions;

const baseInfo = (state: RootState) => state.btest;

export const getBTestState = createSelector(baseInfo, (btest) => btest);
